module.exports = __webpack_public_path__ + "img/img12.f2ae18b0.jpg";